import { render, staticRenderFns } from "./OptionEditSettings.vue?vue&type=template&id=af430936"
import script from "./OptionEditSettings.vue?vue&type=script&lang=js"
export * from "./OptionEditSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports